import React from 'react';

// Components
import RichTextRenderer from '../richTextRenderer';
import Button from '../button';

// Interfaces
import { buttonInterface } from '../../interfaces/button';

function TopBar({
  pageId,
  message,
  menu,
  mobileNav,
}: {
  pageId?: string | undefined;
  message: { raw: string };
  menu: Array<buttonInterface>;
  mobileNav?: boolean;
}) {
  return (
    <React.Fragment>
      {mobileNav ? (
        <div className='cl-navigation-actions__buttons--mobile'>
          {/* Display last menu item of the top bar, mobile */}
          {menu[menu.length - 1] && <Button data={menu[menu.length - 1]} />}
        </div>
      ) : (
        <div className='cl-top-bar'>
          <div className='flex justify-between cl-container'>
            {message && (
              <div className='cl-top-bar__text'>
                <RichTextRenderer text={message} />
              </div>
            )}
            <div className='cl-top-bar__actions'>
              {menu &&
                menu.map((link, index) => {
                  return <Button data={link} key={index} />;
                })}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default TopBar;
